import { Component } from '@angular/core';
import { ResultsDeliveryService } from '@compumark/analyst-selection-tool-client';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-reset-renderer',
  standalone: false,
  templateUrl: './reset-renderer.component.html',
  styleUrls: ['./reset-renderer.component.scss'],
})
export class ResetRendererComponent {
  private params!: ICellRendererParams;
  canReset = false;
  resetting = false;

  constructor(private service: ResultsDeliveryService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.canReset = params.context?.canResetOrders === true;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.canReset = params.context?.canResetOrders === true;
    return true;
  }

  resetOrder(): void {
    if (
      confirm(
        'WARNING: Only reset this order if you have confirmed it is stuck ' +
          '\n\n' +
          'Are you sure you want to reset the status of this order?',
      ) === true
    ) {
      this.resetting = true;
      this.service.resetResultsDeliveryStatus(this.params.data.id).subscribe({
        next: () => {
          this.resetting = false;
          this.params.api.refreshServerSide({ purge: true });
        },
        error: (err: any) => {
          this.resetting = false;
          alert(
            'Failed to reset order: ' +
              (err?.error?.message || err?.message || 'Unknown error'),
          );
        },
      });
    }
  }
}
